<template>
  <JwlModal :controller="roleController">
    <ProfileRoles ref="rolesSelection" @updated="reload" />
  </JwlModal>
</template>
<script setup>
  const roleController = useModal();
  const rolesSelection = ref();

  const reload = () => {
      window.location.reload();
  };

  onMounted(() => {
    window.addEventListener('keyup', (ev) => {
      if (ev.ctrlKey && ev.key === 'l') {
        roleController.open();
        setTimeout(() => {
          rolesSelection.value.roleButton[0].focus();
        }, 500);
      }
    });
  });
</script>
